var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"centered"},[_c('b-icon-question-circle',{attrs:{"font-scale":"4"}}),_c('span',{staticClass:"you-sure mt-4"},[_vm._v("Ești sigur?")]),_c('p',[_vm._v("Aceast cont va fi ștears permanent.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }